import { CheckCircle } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { T } from "./completed-this-month-widget.i18n";
import { KeyFigureValue } from "./key-figure-value";
import { StatsCard } from "./stats-card";

/** Today's Completed This Month figure, unchanged. */
export function CompletedThisMonthWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("completed_this_month", target);
  const t = useT(T);
  const { count } = useDashboardFormat();
  return (
    <StatsCard
      icon={CheckCircle}
      label={t.completedThisMonth}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && count(data.count)}
        </KeyFigureValue>
      }
      subtitle={t.flowInstances}
    />
  );
}
